import React from 'react'

class AgentHeader extends React.Component {
  changeTab = (e, tab) => {
    e.preventDefault()
    this.props.onAgentTabChange(tab)
  }

  renderTabButton = (val, label, length) => {
    const activeClass = this.props.currentTab === val ? 'agent-header__tab-active' : ''
    const classes = `agent-header__tab ${activeClass}`

    if (length !== 0){
      return <a onClick={(e) => this.changeTab(e, val)} className={classes}>{label}</a>
    }
  }

  render() {
    


    return (
      <div className="agent-header">
        <h2 className="agent-header__name">{this.props.agentName}</h2>
        <div className="agent-header__tabs">
          {this.renderTabButton('current', this.props.strings.current, this.props.agentProperties.current.length )}
          {this.renderTabButton('leased', this.props.strings.recently_rented, this.props.agentProperties.leased.length )}
          {this.renderTabButton('sales', this.props.strings.current_sales, this.props.agentProperties.sales.length)}
          {this.renderTabButton('sold', this.props.strings.recently_sold, this.props.agentProperties.sold.length)}
        </div>
      </div>
    )
  }
}

export default AgentHeader



// WEBPACK FOOTER //
// ./src/components/AgentHeader.js